import { ReactElement } from 'react';
import { TitleContainer } from 'components/TitleContainer';
import type { EmbeddedDepartment } from './types';

export function DepartmentTitle({ id, name, className }: EmbeddedDepartment & { className?: string }): ReactElement {
  return <TitleContainer testId={`department-${id}`} className={className} title={name} />;
}
